import styled from 'styled-components';
import { TimePicker } from 'antd';

export const EventDatePickerWrapper = styled.div`
  .ant-picker {
    border: 0 !important;
    .ant-picker-input input {
      font-weight: 400 !important;
      width: auto !important;
      min-width: 128px;
      cursor: pointer !important;
    }
  }
  &.ant-picker-disabled,
  .ant-picker.ant-picker-disabled {
    .ant-picker-input {
      input {
        color: #808080 !important;
        cursor: not-allowed !important;
      }
    }
  }
  & .ant-btn {
    min-width: 128px;
    justify-content: flex-start;
  }
`;

export const EventTimePicker = styled(TimePicker)`
  &.ant-picker {
    border: 0 !important;
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;

    .ant-picker-input {
      input {
        font-weight: 400 !important;
        cursor: pointer !important;
        text-align: left !important;
        padding: 0 !important;
        min-width: 120px;
      }
    }

    .ant-picker-suffix {
      display: none !important; /* Hides the clock icon */
    }

    .ant-picker-clear {
      display: none !important; /* Hides the clear/close button */
    }
  }

  &.ant-picker-disabled {
    .ant-picker-input {
      input {
        color: #808080 !important;
        cursor: not-allowed !important; /* ensure not pointer when disabled */
      }
    }
  }

  &:hover.ant-picker {
    border: 0 !important;
    box-shadow: none !important;
  }

  &.ant-picker-focused {
    border: 0 !important;
    box-shadow: none !important;
  }
`;
